import { useQuery } from '@apollo/client'

import { GetOrganisationSettingsPageHeaderDocument } from '@/graphql/purchase-plus/generated/getOrganisationSettingsPageHeader.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import useOrganisationId from '@/modules/shared/hooks/params/useOrganisationId'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

export const useGetOrganisationSettingsPageHeader = () => {
  const organisationId = useOrganisationId()
  const { data, networkStatus, error, refetch } = useQuery(GetOrganisationSettingsPageHeaderDocument, {
    variables: {
      organisationId: Number(organisationId),
    },
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
  })

  const organisation = data?.organisation

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    error,
    organisation,
    loadingStates,
    refetch,
  }
}
